import React, {Component} from "react";

export default class FieldCheckbox extends Component {

    render() {
        const {className} = this.props;

        const addClass = className ? " " + className : "";

        return (
            <React.Fragment>
                <input type={"checkbox"}
                       className={"text-primary-600 cursor-pointer focus:ring-primary-600 rounded-sm" + addClass}
                       name={this.props.name}
                       checked={!!this.props.value && (this.props.value !== "0")}
                       onChange={(event) => {
                           this.props.onChange(this.props.name, !!event.target.checked);
                       }}
                       disabled={this.props.disabled}
                />
                {this.props.errorMessage && (
                    <div className="field-error-text">
                        <img src="/images/forms/Error.png" alt="error icon" title={`${this.props.errorMessage}`}/>
                    </div>
                )}
            </React.Fragment>
        )
    }
}